export default __webpack_public_path__ + "static/media/icon-account.68a13bfe.svg";